if (typeof TabInfo !== 'function') {
  class TabInfo extends HTMLElement {
    constructor() {
      super();
      this.lastSwitchTime = 0;
    }

    connectedCallback() {
      const tabButtons = this.querySelectorAll('.tab-info__js');
      const firstTab = tabButtons[0];
      const firstTabId = firstTab.dataset.tab;

      // Open first tab by default
      this.openSingleTab(firstTab);

      tabButtons.forEach(button => {
        button.addEventListener('click', () => {
          const tabId = button.dataset.tab;

          // If already active, close it (optional behavior)
          // if (button.classList.contains('active')) {
          //   this.closeAllTabs();
          //   return;
          // }

          // Open clicked tab
          this.openSingleTab(button);

          this.lastSwitchTime = Date.now();
          clearInterval(this.autoSwitchInterval);
          this.startAutoSwitching();
        });
      });

      // this.startAutoSwitching();
    }

    /**
     * Close all tabs and reset icons
     */
    closeAllTabs() {
      const tabButtons = this.querySelectorAll('.tab-info__js');
      const tabContents = this.querySelectorAll('.tab-info-content');

      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        this.updateToggleIcon(btn, false);
        const panel = btn.querySelector('.tab-info__content');
        if (panel) panel.style.maxHeight = null;
      });

      tabContents.forEach(tab => {
        tab.classList.remove('active-tab');
      });
    }

    /**
     * Open only the given tab and close the rest
     */
    openSingleTab(button) {
      const tabId = button.dataset.tab;

      // Close all first
      this.closeAllTabs();

      // Open clicked tab
      this.openTab(tabId);
      button.classList.add('active');
      this.toggleAccordion(button, true);
    }

    openTab(tabId) {
      const tabs = Array.from(this.querySelectorAll('.tab-info-content'));
      tabs.forEach(tab => {
        tab.classList.remove('active-tab');
      });
      document.getElementById(tabId)?.classList.add('active-tab');
    }

    toggleAccordion(button, forceOpen = false) {
      const panel = button.querySelector('.tab-info__content');
      if (!panel) return;

      if (forceOpen) {
        panel.style.maxHeight = panel.scrollHeight + "px";
        this.updateToggleIcon(button, true);
      } else {
        panel.style.maxHeight = null;
        this.updateToggleIcon(button, false);
      }
    }

    updateToggleIcon(button, isOpen) {
      const icon = button.querySelector('.toggle-icon');
      if (!icon) return;

      if (isOpen) {
        icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
        icon.classList.add('open');
        icon.classList.remove('closed');
      } else {
        icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
        icon.classList.add('closed');
        icon.classList.remove('open');
      }
    }
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (event) {
      var blockId = event.detail.blockId;
      activateTabByBlockId(blockId);
      stopAutoSwitching();
    });

    function activateTabByBlockId(blockId) {
      var tabButtons = document.querySelectorAll('.tab-info__js');
      tabButtons.forEach(button => {
        if (button.dataset.id === blockId) {
          button.click();
        }
      });
    }

    function stopAutoSwitching() {
      clearInterval(window.autoSwitchInterval);
    }
  }

  if (typeof customElements.get('tab-info') === 'undefined') {
    customElements.define('tab-info', TabInfo);
  }
}
